import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _html, _markdown;

import BlockTypes from '../../../types/BlockTypes';
import StyleTypes from '../../../types/StyleTypes';
export default {
  html: (_html = {}, _defineProperty(_html, BlockTypes.H1, 'h1'), _defineProperty(_html, BlockTypes.H2, 'h2'), _defineProperty(_html, BlockTypes.H3, 'h3'), _defineProperty(_html, BlockTypes.OL_LI, 'li'), _defineProperty(_html, BlockTypes.OL, 'ol'), _defineProperty(_html, BlockTypes.UL_LI, 'li'), _defineProperty(_html, BlockTypes.UL, 'ul'), _defineProperty(_html, BlockTypes.UNSTYLED, 'p'), _defineProperty(_html, StyleTypes.BOLD, 'b'), _defineProperty(_html, StyleTypes.CODE, 'code'), _defineProperty(_html, StyleTypes.ITALIC, 'i'), _defineProperty(_html, StyleTypes.STRIKETHROUGH, 'del'), _defineProperty(_html, StyleTypes.SUBSCRIPT, 'sub'), _defineProperty(_html, StyleTypes.SUPERSCRIPT, 'sup'), _defineProperty(_html, StyleTypes.UNDERLINE, 'u'), _html),
  markdown: (_markdown = {}, _defineProperty(_markdown, BlockTypes.QUOTE, function (_ref) {
    var children = _ref.children;
    return "> ".concat(children, "\n");
  }), _defineProperty(_markdown, BlockTypes.H1, function (_ref2) {
    var children = _ref2.children;
    return "# ".concat(children, "\n");
  }), _defineProperty(_markdown, BlockTypes.H2, function (_ref3) {
    var children = _ref3.children;
    return "## ".concat(children, "\n");
  }), _defineProperty(_markdown, BlockTypes.H3, function (_ref4) {
    var children = _ref4.children;
    return "### ".concat(children, "\n");
  }), _defineProperty(_markdown, BlockTypes.OL_LI, function (_ref5, i) {
    var children = _ref5.children;
    return "".concat(1, ". ", children, "  \n");
  }), _defineProperty(_markdown, BlockTypes.UL_LI, function (_ref6) {
    var children = _ref6.children;
    return "- ".concat(children, "\n");
  }), _defineProperty(_markdown, StyleTypes.BOLD, function (_ref7) {
    var children = _ref7.children;
    return "**".concat(children, "**");
  }), _defineProperty(_markdown, StyleTypes.CODE, function (_ref8) {
    var children = _ref8.children;
    return "`".concat(children, "`");
  }), _defineProperty(_markdown, StyleTypes.ITALIC, function (_ref9) {
    var children = _ref9.children;
    return "_".concat(children, "_");
  }), _defineProperty(_markdown, StyleTypes.STRIKETHROUGH, function (_ref10) {
    var children = _ref10.children;
    return "~~".concat(children, "~~");
  }), _defineProperty(_markdown, StyleTypes.SUBSCRIPT, function (_ref11) {
    var children = _ref11.children;
    return "<sub>".concat(children, "</sub>");
  }), _defineProperty(_markdown, StyleTypes.SUPERSCRIPT, function (_ref12) {
    var children = _ref12.children;
    return "<sup>".concat(children, "</sup>");
  }), _defineProperty(_markdown, StyleTypes.UNDERLINE, function (_ref13) {
    var children = _ref13.children;
    return "<u>".concat(children, "</u>");
  }), _markdown)
};